import React from 'react';

import {
  CommentItem,
  CommentItemWithHighlight,
} from 'app/comments/components/CommentItem';
import {useCurrentUserState} from 'app/current-user/api';

import type {FilterContentType} from '../types';
import type {CommentSerializedType, ListResponseType} from 'sweet-types';

interface Props {
  data: ListResponseType<CommentSerializedType>;
  canDelete: boolean;
  targetCommentId?: number;
  contentType: FilterContentType;
}

export function CommentListItems({
  data,
  canDelete,
  targetCommentId,
  contentType,
}: Props) {
  const currentUser = useCurrentUserState().data;

  const RenderedCommentItem =
    contentType === 'policy' ||
    contentType === 'procedure' ||
    contentType === 'proceduregroup'
      ? CommentItemWithHighlight
      : CommentItem;

  return (
    <>
      <ul className="list-unstyled mb-0">
        {data.results.map((comment) => (
          <RenderedCommentItem
            canDelete={
              canDelete ||
              (comment.user != null && comment.user.url === currentUser?.url)
            }
            key={comment.id}
            comment={comment}
            isTarget={targetCommentId === comment.id}
          />
        ))}
      </ul>
    </>
  );
}
